import request from '../request'

// MF-67 — Journal severities API (tenant-managed levels: type + points).
export const getSeverities = (params = {}) =>
  request.get('/journal/severities', { params }).then((res) => res)

export const getSeverity = (severityId = '') =>
  request.get(`/journal/severities/${severityId}`).then((res) => res)

export const createSeverity = (data = {}) => request.post('/journal/severities', data).then((res) => res)

export const updateSeverity = (severityId = '', data = {}) =>
  request.put(`/journal/severities/${severityId}`, data).then((res) => res)

export const deleteSeverity = (severityId = '') =>
  request.delete(`/journal/severities/${severityId}`).then((res) => res)
